module.exports = __webpack_public_path__ + "img/card-teenpatti20-live.48ac1e7.jpg";